// extracted by mini-css-extract-plugin
export default {"card":"ScenarioShowcase_card__vFc71","cardActive":"ScenarioShowcase_cardActive__Gf3uS"};